import { ViewModel,View, ObservableArray } from "binder"
import { Property } from "src/formBuilder/structure/components";
import { CustomElementProperty, ElementProperty, FormBuilderElement } from "src/formBuilder/structure/element";
import { BooleanPropertyType, ClassListPropertyType, ContentPropertyType, CustomPropertyType, DatePropertyType, FloatPropertyType, FontStylePropertyType, FontWeightPropertyType, ImagePropertyType, IntegerPropertyType, IPropertyTypeVisitor, ListPropertyType, StringPropertyType, TemplatePropertyType, TemplateSelectorPropertyType, VmFunctionPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { BindingPropertyValue, IElementPropertyValueVisitor, StaticPropertyValue, UnsetPropertyValue } from "src/formBuilder/structure/propertyValue";
import { AddNewPropertyViewModel } from "./addNewProperty/addNewProperty-viewModel";
import { BindingEditorViewModel } from "./editors/bindingEditor/bindingEditor-viewModel";
import { BooleanEditorViewModel } from "./editors/booleanEditory/booleanEditor-viewModel";
import { ClassListEditorViewModel } from "./editors/classListEditor/classListEditor-viewModel";
import { ContentEditorViewModel } from "./editors/contentEditor/contentEditor-viewModel";
import { DateEditorViewModel } from "./editors/dateEditor/dateEditor-viewModel";
import { IntegerEditorViewModel } from "./editors/integerEditor/integerEditor-viewModel";
import { IStaticValueProvider } from "./editors/IStaticValueProvider";
import { ListEditorViewModel } from "./editors/listEditor/listEditor-viewModel";
import { StringEditorViewModel } from "./editors/stringEditor/stringEditor-viewModel";
import { TemplateSelectorEditorViewModel } from "./editors/templateSelectorEditor/templateSelectorEditor-viewModel";
import { VmFunctionEditorViewModel } from "./editors/vmFunctionEditor/vmFunctionEditor-viewModel";
import  { PropertiesPanelView } from "./propertiesPanel-view"
import { FontWeightEditorViewModel } from "./editors/fontWeightEditor/fontWeightEditor-viewModel";
import { FontStyleEditorViewModel } from "./editors/fontStyleEditor/fontStyleEditor-viewModel";
import { ImageEditorViewModel } from "./editors/ImageEditor/imageEditor-viewModel";

export class PropertiesPanelViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.properties = ObservableArray.create<propertyWrapper>();
    }
    GetDefaultView(): View <ViewModel> {
        return new PropertiesPanelView();
    }
    public getTypeId(): string {
        return "VM-D1D72877-EDC9-4EB1-93D4-3A91581E3043"
    }

    public set element(v: FormBuilderElement) { 
        this._element = v; 
        if(this.element!=null){
            this.properties.update(...this.element.properties.map(x=>{
                let result = new propertyWrapper(this);
                result.elementProperty = x;
                return result;
            }));
        }else{
            this.properties.clear();
        }
    } public get element(): FormBuilderElement { return this._element;} private _element: FormBuilderElement;
    public set properties(v: ObservableArray<propertyWrapper>) { this._properties = v; } public get properties(): ObservableArray<propertyWrapper> { return this._properties;} private _properties: ObservableArray<propertyWrapper>;
    
    async AddNewProperty() {
        let popup = new AddNewPropertyViewModel(this);
        let result =await this.requestShowingPopup(popup);
        if(result!=false){
            let attrName = result.propertyName;
            CustomElementProperty.createProperty(this.element,attrName);
            this.updatePropertiesFromElement();
        } 
    }
    public updatePropertiesFromElement(){
        if(this.element!=null){
            this.properties.update(...this.element.properties.map(x=>{
                let result = new propertyWrapper(this);
                result.elementProperty = x;
                return result;
            }));
        }else{
            this.properties.clear();
        }
    }
}

export class propertyWrapper extends ViewModel implements IElementPropertyValueVisitor{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PropertiesPanelViewModel) {
        super(parent);
        this.isInvalid = false;
        this.panel = parent;
    }
    private panel : PropertiesPanelViewModel;
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        this.writtenBinding = this.showingValue;
        this.bindingEditor.setValue(this.writtenBinding);
        return null;
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        this.writtenStaticValue = this.showingValue;
        this.editor.setValue(this.showingValue);
        return null;
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return null;
    }
    
    public set elementProperty(v: ElementProperty) { 
        this._elementProperty = v; 
        this.name = v.property.readableName;
        this.tooltipText = v.property.tooltipText;
        this.isInvalid = v.isInvalid;
        if(v instanceof CustomElementProperty){
            this.isCustom = true;
        }else{
            this.isCustom = false;
        }
        v.validationStatusChanged = isInvalid => this.isInvalid=isInvalid;
        this.showingValue = v.value;
        this.editor = new PropertyEditorFactory().create(this,v);
        this.editor.requestConfirm = ()=>{
            this.setStatic();
        }
        this.bindingEditor = new BindingEditorViewModel(this);
        v.onChangeInternally = ()=> {
            this.showingValue = v.value;
            v.elementPropertyValue.Accept(this,null);
        }
        v.elementPropertyValue.Accept(this,null);
    } public get elementProperty(): ElementProperty { return this._elementProperty;} private _elementProperty: ElementProperty;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set tooltipText(v: string) { this._tooltipText = v; } public get tooltipText(): string { return this._tooltipText;} private _tooltipText: string;
    
    public set showingValue(v: string) { this._showingValue = v; } public get showingValue(): string { return this._showingValue;} private _showingValue: string;
    
    public set editor(v: IStaticValueProvider) { this._editor = v; } public get editor(): IStaticValueProvider { return this._editor;} private _editor: IStaticValueProvider;
    public set bindingEditor(v: BindingEditorViewModel) { this._bindingEditor = v; } public get bindingEditor(): BindingEditorViewModel { return this._bindingEditor;} private _bindingEditor: BindingEditorViewModel;
    

    public set writtenStaticValue(v: string) { this._writtenStaticValue = v; } public get writtenStaticValue(): string { return this._writtenStaticValue;} private _writtenStaticValue: string;
    public set writtenBinding(v: string) { this._writtenBinding = v; } public get writtenBinding(): string { return this._writtenBinding;} private _writtenBinding: string;
    public set isInvalid(v: boolean) { this._isInvalid = v; } public get isInvalid(): boolean { return this._isInvalid;} private _isInvalid: boolean;
    public set isCustom(v: boolean) { this._isCustom = v; } public get isCustom(): boolean { return this._isCustom;} private _isCustom: boolean;
    
    unset(){
        this.elementProperty.unsetValue();
        this.showingValue = this.elementProperty.value;
    }
    setStatic(){
        this.elementProperty.setStaticValue(this.editor.getValue());
        this.showingValue = this.elementProperty.value;
    }
    setBinding(){
        this.writtenBinding = this.bindingEditor.getValue();
        this.elementProperty.setBinding(this.writtenBinding);
        this.showingValue = this.elementProperty.value;
        this.writtenBinding = this.showingValue;
    }

    removePropety(){
        CustomElementProperty.removeProperty(this.elementProperty.element,this.elementProperty.property.name);
        this.panel.updatePropertiesFromElement();
    }
}

class PropertyEditorFactory implements IPropertyTypeVisitor{
    private parent:ViewModel;
    create(parent:ViewModel, property:ElementProperty) : IStaticValueProvider{
        this.parent = parent;
        let result = property.property.propertyType.Accept(this,null);
        return result;
    }

    VisitCustomPropertyType(arg0: CustomPropertyType, parameter: any) {
        return arg0.getEditor(this.parent);
    }
    VisitListPropertyType(arg0: ListPropertyType, parameter: any) {
        return new ListEditorViewModel(this.parent);
    }
    VisitTemplateSelectorPropertyType(arg0: TemplateSelectorPropertyType, parameter: any) {
        return new TemplateSelectorEditorViewModel(this.parent);
    }
    VisitIntegerPropertyType(arg0: IntegerPropertyType, parameter: any) {
        return new IntegerEditorViewModel(this.parent);
    }
    VisitFloatPropertyType(arg0: FloatPropertyType, parameter: any) {
        return new IntegerEditorViewModel(this.parent);
    }

    VisitTemplatePropertyType(arg0: TemplatePropertyType, parameter: any) {
        return new TemplateSelectorEditorViewModel(this.parent);
    }
    VisitContentPropertyType(arg0: ContentPropertyType, parameter: any) {
        return new ContentEditorViewModel(this.parent);
    }
    VisitStringPropertyType(arg0: StringPropertyType, parameter: any) {
        return new StringEditorViewModel(this.parent);
    }
    VisitImagePropertyType(arg0: ImagePropertyType, parameter: any) {
        return new ImageEditorViewModel(this.parent);
    }

    VisitClassListPropertyType(arg0: ClassListPropertyType, parameter: any) {
        return new ClassListEditorViewModel(this.parent);
    }
    
    VisitVmFunctionPropertyType(arg0: VmFunctionPropertyType, parameter: any) {
        return new VmFunctionEditorViewModel(this.parent);
    }
    VisitBooleanPropertyType(arg0: BooleanPropertyType, parameter: any) {
        return new BooleanEditorViewModel(this.parent);
    }
    VisitDatePropertyType(arg0: DatePropertyType, parameter: any) {
        return new DateEditorViewModel(this.parent);
    }
    VisitFontWeightPropertyType(arg0: FontWeightPropertyType, parameter: any) {
        return new FontWeightEditorViewModel(this.parent);
    }
    VisitFontStylePropertyType(arg0: FontStylePropertyType, parameter: any) {
        return new FontStyleEditorViewModel(this.parent);

    }
    
}
